<div class="container-fluid">
  <div class="card col-md-12">
    <div class="card-body" style="min-height: 80vh;">
      <div class="card">
        <div class="card-header">
          <h2 class="orange-border">Fee Summary</h2>
        </div>
      </div>
      <div>
        <div class="row m-0">
          <table class="table table-hover table-responsive-md table-wrap-sm">
            <thead>
              <tr>
                <th></th>
                @for (feeProfileSummary of feeSummary?.feeProfileSummary; track feeProfileSummary) {
                  <th>{{ feeProfileSummary.name }}</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (key of feeProfileSummaryKeys; track key) {
                <tr>
                  <td>{{ getFeeHeading(key) }}</td>
                  @for (feeProfileSummary of feeSummary?.feeProfileSummary; track feeProfileSummary) {
                    <td>
                      {{ getFeeFromFeeProfileSummary(key, feeProfileSummary) }}
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<ngx-ui-loader></ngx-ui-loader>